import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { clockTextSx } from "./HeaderClock.style";

const formatClock = (timezone) => {
  const options = {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZoneName: "short",
  };

  try {
    if (timezone) {
      return new Date().toLocaleTimeString("en-US", {
        ...options,
        timeZone: timezone,
      });
    }
  } catch {
    // Fall through to local time when timezone is invalid.
  }

  return new Date().toLocaleTimeString("en-US", options);
};

const HeaderClock = ({ timezone = "" }) => {
  const [time, setTime] = useState(() => formatClock(timezone));

  useEffect(() => {
    setTime(formatClock(timezone));
    const timer = setInterval(() => {
      setTime(formatClock(timezone));
    }, 1000);

    return () => clearInterval(timer);
  }, [timezone]);

  return (
    <Box component="span" sx={clockTextSx}>
      {time || "—"}
    </Box>
  );
};

HeaderClock.propTypes = {
  timezone: PropTypes.string,
};

export default HeaderClock;
